import React, { forwardRef, useContext } from 'react';
import SignedImage from '@/components/ipe/SignedImage';
import DetailPageScrollContext from '@/contexts/DetailPageScrollContext';

const PLACEHOLDER = <span className="ipe-signed-image-placeholder" aria-hidden="true" />;

/**
 * 图案裁剪详情原图/结果图：与 Studio 原图一致，传入 displayUrl + eager，避免受管地址卡在灰白占位。
 */
const ImageCropDetailMediaImage = forwardRef(function ImageCropDetailMediaImage({
  url,
  displayUrl = '',
  imageId = '',
  alt = '',
  className,
  onError,
  onLoad,
}, ref) {
  const detailScrollRoot = useContext(DetailPageScrollContext);
  const raw = String(url || '').trim();
  if (!raw) return PLACEHOLDER;

  const preview = String(displayUrl || '').trim();
  // 无新鲜签名时不要把空串 / 受管 canonical 塞进 displayUrl，交给 SignedImage 按 url 现签
  const record = imageId
    ? { id: imageId, ...(preview ? { displayUrl: preview, viewUrl: preview } : {}) }
    : null;

  return (
    <SignedImage
      ref={ref}
      url={raw}
      displayUrl={preview || undefined}
      viewUrl={preview || undefined}
      record={record}
      alt={alt}
      className={className}
      loading="eager"
      viewRoot={detailScrollRoot}
      loadingFallback={PLACEHOLDER}
      fallback={PLACEHOLDER}
      onError={onError}
      onLoad={onLoad}
    />
  );
});

export default ImageCropDetailMediaImage;
